import { useState } from "react";
import { useWebSocket } from "react-use-websocket/dist/lib/use-websocket";

type Props = {
  children: React.ReactNode;
};

const Socket: React.FC<Props> = (props) => {
  const [isConnected, setIsConnected] = useState(false);
  useWebSocket(import.meta.env.VITE_SOCKET_PATH, {
    share: true,
    onOpen: () => {
      setIsConnected(true);
    },
    onClose: () => {
      setIsConnected(false);
    },
    onError: () => {
      setIsConnected(false);
    },
    heartbeat: {
      interval: 40 * 1000, // 40 seconds
      timeout: 60 * 1000, // 60 seconds
    },
    shouldReconnect: () => true,
  });
  return <>{isConnected && props.children}</>;
};

export default Socket;
